/** Only phases with a visible bar in the Gantt */
export type GanttVisiblePhase = 'fabricacion' | 'calidad' | 'envasado';

export type GanttPhaseVisualStatus = 'not-started' | 'completed' | 'current' | 'default';

/**
 * Infers which Gantt phase a task object belongs to based on its type / shape.
 * Returns null for cleaning tasks or anything unrecognized.
 */
export function resolveGanttPhaseForTask(task: {
  type?: string;
  packaging_machine?: unknown;
  packaging_time?: unknown;
}): GanttVisiblePhase | null {
  if (task.packaging_machine != null || task.packaging_time != null) return 'envasado';
  if (task.type === 'order') return 'fabricacion';
  if (task.type === 'calidad') return 'calidad';
  return null;
}

/**
 * Maps Kanbanize bloque estado (null | En Progreso | Terminado) to Gantt colors.
 */
export function resolvePackagingGanttPhaseStatus(
  estado: string | undefined | null,
): GanttPhaseVisualStatus {
  if (!estado) return 'not-started';
  if (estado === 'En Progreso') return 'current';
  if (estado === 'Terminado') return 'completed';
  return 'default';
}

/**
 * Single entry point for the timeline: infers the phase from the task shape and
 * reads the matching `*_estado` field from the API (parent order or packaging line).
 */
export function resolveGanttStatusForTask(task: {
  type?: string;
  fabricacion_estado?: string | null;
  calidad_estado?: string | null;
  envasado_estado?: string | null;
  packaging_machine?: unknown;
  packaging_time?: unknown;
}): GanttPhaseVisualStatus {
  const phase = resolveGanttPhaseForTask(task);
  if (!phase) return 'default';
  if (phase === 'envasado') return resolvePackagingGanttPhaseStatus(task.envasado_estado);
  if (phase === 'fabricacion') return resolvePackagingGanttPhaseStatus(task.fabricacion_estado);
  return resolvePackagingGanttPhaseStatus(task.calidad_estado);
}
